import apiClient from './api'

export interface Dentist {
  id: number
  firstName: string
  lastName: string
  email: string
}

class DentistService {
  async GetDentists() {
    try {
      const response = await apiClient.get<Dentist[]>('/Admin/dentists')
      return { success: true, data: response.data }
    } catch (err) {
      return { success: false, data: [] as Dentist[] }
    }
  }
}

export default new DentistService()
